<template>
  <div class="recruit-activities-nov-detail">
    <img src="../../../assets/recruit/191101.jpeg" alt="" width="100%" />
  </div>
</template>
<style scoped lang="scss">
.recruit-activities-nov-detail {
  background: #c23226;
}
</style>
<script>
export default {
  name: "recruit-activities-nov-module",
  data() {
    return {
      startTime: this.$route.query.s || 0,
      endTime: this.$route.query.e || 0,
      diffDay: this.$route.query.d * 1 || 0
    };
  },
  components: {},
  methods: {},
  created() {
    this.$store.commit("comp/WX_SHARE", {
      title: document.title,
      desc:
        this.startTime +
        "至" +
        this.endTime +
        (this.diffDay > 0 ? " 距活动结束还有" + this.diffDay + "天" : "")
    });
  }
};
</script>
